export default "__VITE_ASSET__d07758ef__"